import { connect } from 'react-redux';

import { AppHeader } from 'components';
import { logout } from 'actions/auth';

export default connect(null, {
  logout,
})(AppHeader);
